<template>
  <div class="div" ref="hot-word-analysis"></div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import {chartColors} from './constant'
import ResizeObserver from 'resize-observer-polyfill'

export default {
  name: 'HotWordAnalysis', // 热词分析
  props: {
    type: {
      type: String
    },
    wordData: {
      type: Array,
      default: () => {
        return []
      }
    },
    sizeRange:{
      type:Array,
      default: ()=>{
        return [12, 30]
      }
    }
  },
  data(){
    return {
      myChart: null,
      resizeObserver: null,
    }
  },
  mounted () {
    this.onWindowResize = () => {
      this.resize()
    }
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(() => {
      this.hotWordAnalysis()
    })
  },
  methods: {
    randcolor (val) {
      const color = ['#005b89', '#0974b6', '#1796a9', '#25beee'][val.dataIndex % 3]
      return color
    },
    getContainerHeight (entry) {
      if (!entry) return 0
      if (entry.borderBoxSize && entry.borderBoxSize.length) {
        return entry.borderBoxSize[0].blockSize
      }
      return entry.contentRect ? entry.contentRect.height : 0
    },
    hotWordAnalysis () {
      const that = this
      if (this.myChart) {
        this.myChart.dispose()
        this.myChart = null
      }
      const countContrastDom = this.$refs['hot-word-analysis']
      if (!countContrastDom) return
      this.myChart = echarts.init(countContrastDom)

      let option = {
        color: ['#005b89', '#0974b6', '#1796a9', '#25beee'],
        tooltip: {
          show: true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
        },
        grid: {
          bottom: '10%',
          top: '10%',
          left: 0,
          right: 0
        },
        series: [{
          type: 'wordCloud',
          width: '90%',
          height: '90%',
          drawOutOfBound: false,
          layoutAnimation: true,
          gridSize: 8,
          // size: ['9%', '99%'],
          // sizeRange: [10, 30],
          // textRotation: [0, 45, 90, -45],
          // rotationRange: [-45, 45],
          rotationRange: [-90, 90],
          rotationStep: 45,
          // shape: 'triangle', // "circle", "triangle", "star", "pentagon", and "diamond".
          textPadding: 0,
          autoSize: {
            enable: true,
            minSize: 6,
          },
          sizeRange: that.sizeRange,
          textStyle: {
            color: params => {
              return this.randcolor(params)
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: '#333'
            }
          }
        }]
        // maskImage: imagePath
      }

      option.series[0].data = this.wordData

      let self = this
      this.myChart.on('click', function (params) {
        self.$emit('hotClick', params.data.name)
      })

      this.myChart.clear()
      this.myChart.setOption(option)

      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
      this.resizeObserver = new ResizeObserver((entries) => {
        const height = that.getContainerHeight(entries && entries[0])
        if (height > 0) {
          that.resize()
        }
      })
      this.resizeObserver.observe(countContrastDom)
    },
    resize() {
      if(this.myChart != null) {
        this.myChart.resize();
      }
    }
  },

  activated() {
    this.$nextTick(() => {
      if (this.myChart) {
        this.resize()
      } else if (this.wordData && this.wordData.length) {
        this.hotWordAnalysis()
      }
    })
  },
  destroyed () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    if (this.onWindowResize) {
      window.removeEventListener('resize', this.onWindowResize)
    }
    if (this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
  watch: {
    wordData: {
      handler () {
        this.$nextTick(() => {
          this.hotWordAnalysis()
        })
      },
      deep: true
    }
  },
}
</script>

<style scoped>
  .div {
    width: 100%;
    height: 100%;
  }
</style>
